export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY : ''

export const GENERIC_ERROR_MESSAGE = 'Daten konnten nicht aktualisiert werden.'
export const TRAINING_APPOINTMENT_TYPE_FRAGMENT = 'schulung'
export const VISIT_APPOINTMENT_TYPE_FRAGMENT = 'besuch'
export const REMOTE_APPOINTMENT_TYPE_FRAGMENT = 'remote-schulung'
export const EMPTY_STATUS_ID = 'null'
export const TRAINING_COMPLETED = 'schulung durchgeführt'
export const TRAINING_BOOKED = 'avisiert'
